import React, { Component } from "react";
import AntdLayout, {LayoutProps} from "antd/lib/layout";
import "antd/lib/layout/style";

const { Header, Content, Footer, Sider } = AntdLayout;

export default class Layout extends Component<LayoutProps> {
  static Header = Header;
  static Content = Content;
  static Footer = Footer;
  static Sider = Sider;
  render() {
    return <AntdLayout {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/index.tsx